import axios from "axios";
import store from "../store";
import router from "../router";
import querystring from "querystring";

class arefApi {
  setLogout() {
    store.commit("set", ["token", null]);
    store.commit("set", ["menus", null]);
    store.commit("set", ["cartCount", 0]);
    store.commit("set", ["cartAmount", 0]);
    store.commit("set", ["user_id", null]);
    store.commit("unset", "socket");
    store.commit("disconnectSocket");
    router.push({ name: `RegisterLogin` });
  }

  async apiRequest(method, route, data, isAuth = true, formData = false) {
    const url = `${process.env.VUE_APP_API_URL}${route}`;
    const config = {
      method,
      url,
      data,
      onUploadProgress: function(progressEvent) {
        const uploadPercentage = parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        );
        store.commit("set", ["uploadPercentage", uploadPercentage]);
      },
    };
    if (isAuth) {
      config["headers"] = {
        Authorization: `Bearer ${store.state.token}`,
      };
    }
    if (formData) {
      config["headers"] = {
        Authorization: `Bearer ${store.state.token}`,
        "Content-Type": "multipart/form-data",
      };
    }
    return new Promise((resolve, reject) => {
      axios(config)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.setLogout();
          }
          reject(err.response);
        });
    });
  }

  async apiUserRequest(method, route, data, isAuth = true, formData = false) {
    let url = `${process.env.VUE_APP_USER_API_URL}${route}${
      route.indexOf("?") > 0 ? "&" : "?"
    }nocache=${new Date().getTime()}`;
    const config = {
      method,
      url,
      data,
      withCredentials: true,
      onUploadProgress: function(progressEvent) {
        const uploadPercentage = parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        );
        store.commit("set", ["uploadPercentage", uploadPercentage]);
      },
    };
    if (isAuth) {
      config["headers"] = {
        Authorization: `Bearer ${store.state.token}`,
      };
    }
    if (formData) {
      config["headers"] = {
        Authorization: `Bearer ${store.state.token}`,
        "Content-Type": "multipart/form-data",
      };
    }
    return new Promise((resolve, reject) => {
      axios(config)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            console.log("apiUserRequest", route, window.location.href);
            this.setLogout();
          }
          reject(err.response);
        });
    });
  }

  logout() {
    if (!store.state.token) {
      router.push({ name: "RegisterLogin" });
      return;
    }
    this.apiRequest(`post`, `auth/logout`, {}).finally(() => {
      this.setLogout();
    });
  }

  login(loginData) {
    return new Promise((resove, reject) => {
      this.apiRequest(`post`, `auth/login`, loginData, false)
        .then((resp) => {
          resove(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  registerLogin(mobileData) {
    return this.apiRequest(`post`, `auth/register-login`, mobileData, false);
  }

  loginWithOtp(userData) {
    return this.apiRequest(`post`, `auth/login-with-otp`, userData, false);
  }

  registerWithOtp(userData) {
    return this.apiRequest(`post`, `auth/register-with-otp`, userData, false);
  }

  forgetPassSendCode(forgetData) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`post`, `auth/forget-password`, forgetData, false)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  verifyOtpAndChangePass(forgetData) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`post`, `auth/verify-forget-password`, forgetData, false)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  //--------------------------Users--------------------------------
  async getUsersIndex(page) {
    return this.apiRequest(`get`, `users?page=${page}`);
  }

  async addUser(newUser) {
    return this.apiRequest(`post`, `users/add`, newUser);
  }

  async editUser(editUser) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`put`, `users/edit`, editUser)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async getUser(userId) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`get`, `users/get/${userId}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  }

  async searchUser(params) {
    let queryString = querystring.stringify(params);
    return this.apiRequest(`get`, `users/search?${queryString}`);
  }

  getUserProfile() {
    return this.apiUserRequest(`get`, `auth/user-profile`);
  }

  /** 
   * ADMIN
  block a user 
  * @param {number} userId
  */
  blockUser(userId) {
    return this.apiRequest(`get`, `users/block/${userId}`);
  }

  /** 
   * ADMIN
  unblock a user 
  * @param {number} userId
  */
  unBlockUser(userId) {
    return this.apiRequest(`get`, `users/unblock/${userId}`);
  }

  /** 
   * ADMIN
  get blocked uses list
  */
  getBlockedUsers() {
    return this.apiRequest(`get`, `users/show-all-block`);
  }

  async editUserProfile(editUser) {
    return new Promise((resolve, reject) => {
      this.apiUserRequest(`put`, `auth/user-profile`, editUser)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //-----------------End Users --------------------
  async getCities(isRegisterdUser = false) {
    const fn = isRegisterdUser ? "apiUserRequest" : "apiRequest";
    return new Promise((resolve, reject) => {
      this[fn](`get`, `cities?per_page=all`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  }

  async getProvinces() {
    return this.apiRequest(`get`, `provinces?per_page=all`);
  }

  async getUserProvinces() {
    return this.apiUserRequest(`get`, `provinces?per_page=all`);
  }

  async GetCitiesOfAProvince(province_id, isRegisterdUser = false) {
    const fn = isRegisterdUser ? "apiUserRequest" : "apiRequest";
    return this[fn](`get`, `provinces/get-cities-of-a-province/${province_id}`);
  }

  async getGroups() {
    return this.apiRequest(`get`, `groups`);
  }

  async bulkDeleteUser(ids) {
    return this.apiRequest(`patch`, `users/bulk-delete`, ids);
  }

  async register(registerData) {
    return this.apiRequest(`post`, `auth/register`, registerData, false);
  }

  async verify(otpData) {
    return this.apiRequest(`post`, `auth/verify`, otpData, false);
  }

  async changePassword(passData) {
    return this.apiUserRequest(`patch`, `auth/change-password`, passData);
  }
  //---------------- Products ---------------------
  async getProductsIndex(page, all = false, searchDataParams) {
    const queryString = searchDataParams
      ? querystring.stringify(searchDataParams)
      : "";
    return this.apiRequest(
      `get`,
      `products?page=${page}${all ? "&per_page=all" : ""}&${queryString}`
    );
  }

  async getProduct(productId) {
    return this.apiRequest(`get`, `products/getProduct/${productId}`);
  }

  async getExams() {
    return this.apiRequest(`get`, `products/quiz24/exams`);
  }
  async getExamManifest(examId,page=1) {
    return this.apiRequest(`get`, `products/get-quiz-manifest/${examId}?page=${page}`);
  }

  async editProduct(editProduct) {
    return new Promise((resolve, reject) => {
      this.apiRequest(
        `put`,
        `products/edit/${editProduct.id}`,
        editProduct,
        true
      )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async addProduct(addProduct) {
    return this.apiRequest(`post`, `products/add`, addProduct);
  }

  async deleteProduct(productId) {
    return this.apiRequest(`delete`, `products/${productId}`);
  }

  async setProductMainImage(formData, productId) {
    return this.apiRequest(
      `post`,
      `products/set-main-image/${productId}`,
      formData,
      true,
      true
    );
  }

  deleteProductMainImage(productId) {
    return this.apiRequest(`delete`, `products/main-image/${productId}`);
  }

  async getProductVideoSessions(productId, page, all = false) {
    return this.apiRequest(
      `get`,
      `products/get-videos/${productId}?page=${page}&${
        all ? "per_page=all" : ""
      }`
    );
  }

  deleteProductFile(fileId) {
    return this.apiRequest(`delete`, `product-files/${fileId}`);
  }

  setProductFile(formData) {
    return this.apiRequest(`post`, `product-files/add/`, formData, true, true);
  }

  getUserCategoryOneProducts(categoryOneId) {
    return this.apiUserRequest(
      `get`,
      `products?category_ones_id=${categoryOneId}&per_page=all`
    );
  }

  getUserProductVideoSessions(productId, page, all = false) {
    return this.apiUserRequest(
      `get`,
      `products/get-videos/${productId}?page=${page}&${
        all ? "per_page=all" : ""
      }`
    );
  }

  async getUserProduct(productId) {
    return this.apiUserRequest(`get`, `products/getProduct/${productId}`);
  }

  async getUserExams() {
    return this.apiUserRequest(`get`, `products/quiz24/exams`);
  }


  async getUserExamUrl(examId) {
    return this.apiUserRequest(`get`, `products/get-quiz-url/${examId}`);
  }

  async getUserExamResult(examId) {
    return this.apiUserRequest(`get`, `products/get-quiz-result/${examId}`);
  }

  addProductToPackage(childData) {
    return this.apiRequest(`post`, `product-detail-packages/add`, childData);
  }

  getChildProducts(productId) {
    return this.apiRequest(`get`, `products/get-packages/${productId}`);
  }

  deleteChlidProduct(productDetailPackagesId) {
    return this.apiRequest(
      `delete`,
      `product-detail-packages/${productDetailPackagesId}`
    );
  }

  getUserChildProducts(productId) {
    return this.apiUserRequest(
      `get`,
      `products/get-packages-in-group/${productId}?per_page=all`
    );
  }

  getAdminChildProducts(productId) {
    return this.apiRequest(
      `get`,
      `products/get-packages-in-group/${productId}?per_page=all`
    );
  }

  addProductComment(commentData) {
    return this.apiUserRequest(`post`, `product-comments/add`, commentData);
  }

  getUserProductComments(productId) {
    return this.apiUserRequest(`get`, `product-comments/show/${productId}`);
  }

  getAllComments(commentData) {
    return this.apiRequest(
      `get`,
      `product-comments/search?verified=${commentData.verified}&per_page=${
        commentData.per_page ? commentData.per_page : ""
      }&page=${commentData.page ? commentData.page : 1}&products_id=${
        commentData.productId
      }`
    );
  }

  editComment(commentData) {
    return this.apiRequest(`put`, `product-comments/edit/${commentData.id}`, {
      verified: commentData.verified,
    });
  }

  deleteComment(commentId) {
    return this.apiRequest(`delete`, `product-comments/${commentId}`);
  }
  //----------------End Products ---------------------

  //---------------- Categoryones ------------------------
  async getCategoryonesIndex(page, all = false) {
    return this.apiRequest(
      `get`,
      `category-ones?page=${page}&${all ? "per_page=all" : ""}`
    );
  }

  async getCategoryone(categoryoneId) {
    return this.apiRequest(`get`, `category-ones/show/${categoryoneId}`);
  }

  async addCategoryone(addCategoryone) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`post`, `category-ones/add`, addCategoryone)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async editCategoryone(editCategoryone) {
    return new Promise((resolve, reject) => {
      this.apiRequest(
        `put`,
        `category-ones/edit/${editCategoryone.id}`,
        editCategoryone
      )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async deleteCategoryone(categoryoneId) {
    return this.apiRequest(`delete`, `category-ones/${categoryoneId}`);
  }

  async getCategoryoneSubset(categoryoneId) {
    return this.apiRequest(`get`, `category-ones/get-subset/${categoryoneId}`);
  }

  async setCategoryoneImage(formData, categoryoneId) {
    return this.apiRequest(
      `post`,
      `category-ones/set-image/${categoryoneId}`,
      formData,
      true,
      true
    );
  }

  deleteCategoryoneImage(categoryoneId) {
    return this.apiRequest(`delete`, `category-ones/image/${categoryoneId}`);
  }

  async getUserCategoryonesIndex(page, all = false) {
    return this.apiUserRequest(
      `get`,
      `category-ones?page=${page}&${all ? "per_page=all" : ""}`
    );
  }
  //----------------End Categoryones ------------------------

  //---------------- Categorytwos ------------------------
  async getCategorytwosIndex(page, all = false) {
    return this.apiRequest(
      `get`,
      `category-twos?page=${page}&${all ? "per_page=all" : ""}`
    );
  }

  async getCategorytwo(categorytwoId) {
    return this.apiRequest(`get`, `category-twos/show/${categorytwoId}`);
  }

  async addCategorytwo(addCategorytwo) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`post`, `category-twos/add`, addCategorytwo)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async editCategorytwo(editCategorytwo) {
    return new Promise((resolve, reject) => {
      this.apiRequest(
        `put`,
        `category-twos/edit/${editCategorytwo.id}`,
        editCategorytwo
      )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async deleteCategorytwo(categorytwoId) {
    return this.apiRequest(`delete`, `category-twos/${categorytwoId}`);
  }

  async getCategorytwoSubset(categorytwoId) {
    return this.apiRequest(`get`, `category-twos/get-subset/${categorytwoId}`);
  }
  //----------------End Categorytwos ------------------------

  //---------------- Categorythrees ------------------------
  async getCategorythreesIndex(page, all = false) {
    return this.apiRequest(
      `get`,
      `category-threes?page=${page}&${all ? "per_page=all" : ""}`
    );
  }

  async getCategorythree(categorythreeId) {
    return this.apiRequest(`get`, `category-threes/show/${categorythreeId}`);
  }

  async addCategorythree(addCategorythree) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`post`, `category-threes/add`, addCategorythree)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async editCategorythree(editCategorythree) {
    return new Promise((resolve, reject) => {
      this.apiRequest(
        `put`,
        `category-threes/edit/${editCategorythree.id}`,
        editCategorythree
      )
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async deleteCategorythree(categorythreeId) {
    return this.apiRequest(`delete`, `category-threes/${categorythreeId}`);
  }
  //----------------End Categorythrees ------------------------

  //---------------- Coupons ------------------------
  async getCouponsIndex(page, all = false, name = "",school_id= undefined) {
    return this.apiRequest(
      `get`,
      `coupons?${name !== "" ? "name=" + name + "&" : ""}page=${page}&${
        all ? "per_page=all" : ""
      }${school_id ? "school_id=" + school_id + "&" : ""}`
    );
  }

  async getSagIndex(page, all = false) {
    return this.apiRequest(
      `get`,
      `users?page=${page}&${all ? "per_page=all" : ""}`
    );
  }

  // async getProductsIndex(page, all = false) {
  //   return this.apiRequest(
  //     `get`,
  //     `products?page=${page}&${all ? "per_page=all" : ""}`
  //   );
  // }

  async getCoupon(couponId) {
    return this.apiRequest(`get`, `coupons/show/${couponId}`);
  }

  async addCoupon(addCoupon) {
    return this.apiRequest(`post`, `coupons/add`, addCoupon);
  }

  async editCoupon(editCoupon) {
    return this.apiRequest(`put`, `coupons/edit/${editCoupon.id}`, editCoupon);
  }

  async deleteCoupon(couponId) {
    return this.apiRequest(`delete`, `coupons/${couponId}`);
  }
  //----------------End Coupons ------------------------

  //---------------------Videos-------------------------
  async insertVideos(videoData) {
    return this.apiRequest(`post`, `video-sessions/add-video`, videoData);
  }
  async insertSingleProduct(videoData) {
    return this.apiRequest(`post`, `video-sessions/add-one-video`, videoData);
  }

  //-------------------End Videos-------------------------

  //------------------Product Detail Videos---------------------------------
  async assignVideoToProduct(data) {
    return this.apiRequest(
      `post`,
      `product-detail-videos/assign-video-to-a-product`,
      data
    );
  }

  async deleteProductDetailVideo(id) {
    return this.apiRequest(`delete`, `product-detail-videos/${id}`);
  }

  async getProductVideoSessionInfo(id) {
    return this.apiRequest(`get`, `product-detail-videos/show/${id}`);
  }

  async getUserProductVideoSessionInfo(id) {
    return this.apiUserRequest(`get`, `product-detail-videos/show/${id}`);
  }

  async editProductVideoSession(editData) {
    return this.apiRequest(
      `put`,
      `video-sessions/edit-one-video/${editData.id}`,
      editData
    );
  }

  setVideoSessionFile(formData) {
    return this.apiRequest(
      `post`,
      `video-session-files/add`,
      formData,
      true,
      true
    );
  }

  deleteSessionFile(fileId) {
    return this.apiRequest(`delete`, `video-session-files/${fileId}`);
  }

  assignFile(data) {
    return this.apiRequest(
      `post`,
      `video-session-files/add-new-by-getting-file-info/`,
      data
    );
  }

  getConferenceInfo(productDetailVideosId) {
    return this.apiUserRequest(
      `get`,
      `product-detail-videos/get-conference-info/${productDetailVideosId}`,
      false,
      false
    );
  }
  //------------------End Product Detail Videos-----------------------------

  //----------------------Cart -----------------------------------------------
  addProductToCart(productData) {
    return this.apiUserRequest(`post`, `cart/add`, productData);
  }

  addMicroProductToCart(productData) {
    return this.apiUserRequest(`post`, `cart/add-micro-product`, productData);
  }

  getCart() {
    return this.apiUserRequest(`get`, `cart/get-whole-cart`);
  }

  deleteProductFromCart(order_details_id) {
    return this.apiUserRequest(`delete`, `cart/${order_details_id}`);
  }

  deleteMicroProductFromCart(order_details_id, product_details_id) {
    const obj = {
      product_details_id,
    };
    return this.apiUserRequest(
      `delete`,
      `cart/micro-product/${order_details_id}`,
      obj
    );
  }

  emptyCart() {
    return this.apiUserRequest(`delete`, `cart/destroy-whole-cart`);
  }

  completeBuying() {
    return this.apiUserRequest(`get`, `cart/complete-buying`);
  }

  addCouponToCart(couponData) {
    return this.apiUserRequest(`put`, `cart/add-coupon`, couponData);
  }

  /** 
  delete a chair from Cart
  * @param {number} chairId 
  */
  deleteChairFromCard(chairId) {
    return this.apiUserRequest(`delete`, `cart/chair/${chairId}`);
  }

  /** 
  delete chair number from Cart
  * @param {number} productId 
  * @param {number} chairNumber 
  */
  deleteChairNumberFromCard(productId, chairNumber) {
    return this.apiUserRequest(
      `delete`,
      `cart/chair-product/${productId}/${chairNumber}`
    );
  }

  /** 
  add package group to card
  * @param {array} data.child_product_ids 
  * @param {number} data.products_id 
  */
  addProductPackage(data) {
    return this.apiUserRequest(`post`, `cart/add-package-product`, data);
  }

  //----------------------End Cart -----------------------------------------------
  //-----------------------Order--------------------------------------------------
  getUserOrders() {
    return this.apiUserRequest(`get`, `order/show-factors-of-user`);
  }

  getOrderDetails(orderId) {
    return this.apiUserRequest(`get`, `order/get-info-of-an-order/${orderId}`);
  }

  getAdminOrderDetails(orderId) {
    return this.apiRequest(`get`, `orders/get-info-of-an-order/${orderId}`);
  }

  completeCoursesOfUser() {
    return this.apiUserRequest(`get`, `order/complete-courses-of-user`);
  }

  singleSessionsOfUser() {
    return this.apiUserRequest(`get`, `order/single-sessions-of-user`);
  }

  //Order Admin part------------
  addNewOrder(userData) {
    return this.apiRequest(`post`, `orders/add`, userData);
  }

  addProductToOrder(orderId, productData) {
    return this.apiRequest(
      `post`,
      `orders/add-orderdetail-product/${orderId}`,
      productData
    );
  }

  addVideoSessionToOrder(orderId, productData) {
    return this.apiRequest(
      `post`,
      `orders/add-micro-product/${orderId}`,
      productData
    );
  }

  addPackageToOrder(packagetData) {
    return this.apiRequest(`post`, `orders/add-package-product`, packagetData);
  }

  deleteProductFromOrder(orderId, order_details_id) {
    return this.apiRequest(
      `delete`,
      `orders/product/${orderId}/${order_details_id}`
    );
  }

  deleteMicroProductFromOrder(orderId, order_details_id, product_details_id) {
    const obj = {
      product_details_id,
    };
    return this.apiRequest(
      `delete`,
      `orders/micro-product/${orderId}/${order_details_id}`,
      obj
    );
  }

  emptyOrder(orderId) {
    return this.apiRequest(`delete`, `orders/cart/${orderId}`);
  }

  completeOrder(orderId, orderData) {
    return this.apiRequest(
      `post`,
      `orders/complete-buying/${orderId}`,
      orderData
    );
  }

  cancelBuyingProduct(cancelData) {
    return this.apiRequest(`post`, `orders/cancel-buying-product`, cancelData);
  }

  cancelBuyingProductDetail(cancelData) {
    return this.apiRequest(
      `post`,
      `orders/cancel-buying-micro-product`,
      cancelData
    );
  }
  //End Order Admin part--------
  //-----------------------End Order---------------------------------------------
  //-----------------------Video Sessions----------------------------------------
  getFreeSessions() {
    return this.apiUserRequest(`get`, `sessions/free`);
  }

  getFreeQuizes() {
    return this.apiUserRequest(`get`, `products/get-free-quiz`);
  }

  getMyQuizes() {
    return this.apiUserRequest(`get`, `products/get-quiz-products`);
  }

  getCurrentWeekSessions() {
    return this.apiUserRequest(`get`, `order/show-student-sessions`);
  }

  getWeeklyQuizProducts() {
    return this.apiUserRequest(`get`, `products/get-weekly-quiz-products`);
  }

  getWeeklyFreeQuizProducts() {
    return this.apiUserRequest(`get`, `products/get-weekly-free-quiz`);
  }

  getLiveSessions() {
    return this.apiUserRequest(`get`, `sessions/today`);
  }

  async setVideoSessionPresentsSkyRoom(videoSessionId) {
    return this.apiUserRequest(
      `post`,
      `sessions/present`,
       {
        video_session_id:videoSessionId
       }      
       );
  }
  //-----------------------END Video Sessions----------------------------------------
  //-----------------------Reports --------------------------------------------------
  saleReport(reportData) {
    return this.apiRequest(`post`, `user-products/report-sale`, reportData);
  }

  productSummaryReport(productId) {
    return this.apiRequest(`get`, `user-products/product-summary/${productId}`);
  }

  presenceReport(product_detail_videos_id) {
    return this.apiRequest(
      `get`,
      `user-video-session-presents/report?product_detail_videos_id=${product_detail_videos_id}`
    );
  }
  //-----------------------End Reports ----------------------------------------------
  //-----------------------Homeworks-------------------------------------------------

  attackHomeworkToVideoSession(formData, user_video_session_homeworks_id) {
    return this.apiUserRequest(
      `post`,
      `homework/concat-homework-to-session/${user_video_session_homeworks_id}`,
      formData,
      true,
      true
    );
  }

  setHomeworkDescription(dataObj, videoSessionId) {
    return this.apiUserRequest(
      `post`,
      `homework/add-description/${videoSessionId}`,
      dataObj
    );
  }

  //-----------------------END Homeworks---------------------------------------------

  //------------------------ Start conferenceUser -----------------------------------
  /** 
  add user to free-conference
  * @param {number} conferenceData.product_detail_videos_id
  * @param {number} conferenceData.users_id
  * @param {string} conferenceData.referrer max:4096
  */
  addUserToConference(conferenceData) {
    return this.apiUserRequest(
      `post`,
      `conference-users/add-user`,
      conferenceData
    );
  }

  /** 
  get confernces list
  */
  getAllConferencesList() {
    return this.apiRequest(`get`, `conference-users/getall`);
  }

  getConferenceReport(product_detail_videos_id) {
    return this.apiRequest(
      `get`,
      `conference-users/report/${product_detail_videos_id}`
    );
  }
  //------------------------ End  conferenceUser ------------------------------------

  //------------------------ Start ProductDetailChairs -----------------------------------
  /** 
  add chairs to productDetailchairs
  * @param {number} chairsData.products_id 
  * @param {number} chairsData.start
  * @param {number} chairsData.end
  * @param {number} chairsData.price
  * @param {string} chairsData.description
  */
  addChairs(chairsData) {
    return this.apiRequest(`post`, `product-detail-chairs/add`, chairsData);
  }

  /** 
  delete chairs from productDetailchairs
  * @param {number} id 
  */
  deleteChairs(id) {
    return this.apiRequest(`delete`, `product-detail-chairs/${id}`);
  }

  /** 
  get a product chairs
  * @param {number} products_id 
  */
  getProductChairs(products_id, page = 1, all = false) {
    return this.apiRequest(
      `get`,
      `product-detail-chairs/${products_id}?page=${page}&${
        all ? "per_page=all" : ""
      }`
    );
  }

  /** 
  get a product chairs and reserved chairs for user to show
  * @param {number} products_id 
  */
  getUserProductChairs(products_id, page = 1, all = false) {
    return this.apiUserRequest(
      `get`,
      `products/get-chairs/${products_id}?page=${page}&${
        all ? "per_page=all" : ""
      }`
    );
  }
  //------------------------ End  ProductDetailChairs ------------------------------------

  //------------------------Start Team users ----------------------------------------------
  /** 
  get team users
  */
  getTeamUser() {
    return this.apiUserRequest(`get`, `team-user`);
  }

  /** 
  add Team
  * @param {number} data.name 
  */
  addTeam(data) {
    return this.apiUserRequest(`post`, `team-user`, data);
  }

  /** 
  get team_user_member
  * @param {number} data.mobile 
  */
  addTeamMembers(data) {
    return this.apiUserRequest(`post`, `team-user-member`, data);
  }

  /** 
  verify membership
  * @param {number} team_user_id 
  */
  verifymembership(team_user_id) {
    return this.apiUserRequest(`put`, `verify-membership/${team_user_id}`);
  }

  /** 
   * ADMIN
  get teams 
  */
  getTeams(page = 1, mobile = null) {
    const searchQuery = mobile ? `mobile=${mobile}&` : "";
    return this.apiRequest(
      `get`,
      `team-users/report/all-team?${searchQuery}page=${page}`
    );
  }

  /** 
   * ADMIN
  delete a team member
  * @param {number} team_user_member_id
  */
  deleteATeamMember(team_user_member_id) {
    return this.apiRequest(
      `delete`,
      `team-users/team-mobile/${team_user_member_id}`
    );
  }

  /** 
   * ADMIN
  add a team member
  * @param {string} data.mobile
  * @param {string} data.team_user_id
  */
  addATeamMember(data) {
    return this.apiRequest(`post`, `team-users/team-mobile`, data);
  }

  /** 
   * ADMIN
  delete a team 
  * @param {number} team_user_id
  */
  deleteTeam(team_user_id) {
    return this.apiRequest(`delete`, `team-users/${team_user_id}`);
  }
  //------------------------End Team users-------------------------------------------------

  /** 
   * ADMIN
  get free sessions 
  * @param {number} team_user_id
  */
  getAdminFreeSessions() {
    return this.apiRequest(`get`, `sessions/free`);
  }

  hideProductDetailVideo(productDetailVideosId, status) {
    return this.apiRequest(
      `patch`,
      `product-detail-videos/${productDetailVideosId}/${
        status ? "show-in-free" : "hide-in-free"
      }`
    );
  }

  //------------------------Start Schools ----------------------------------------------
  getSchoolsIndex(page = 1, name = "", all = false) {
    const searchQuery = name ? `name=${name}&` : "";
    return this.apiRequest(
      `get`,
      `schools?page=${page}&${searchQuery}${all ? "per_page=all" : ""}`
    );
  }

  async addSchool(newSchool) {
    return this.apiRequest(`post`, `schools`, newSchool);
  }

  async getSchool(schoolId) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`get`, `schools/${schoolId}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  }

  async editSchool(editSchool) {
    return new Promise((resolve, reject) => {
      this.apiRequest(`put`, `schools/${editSchool.id}`, editSchool)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } 
  //------------------------End Schools ----------------------------------------------
  //------------------------Start Banners ----------------------------------------------
  getBannersIndex(page = 1, all = true) {
    return this.apiRequest(`get`, `banners?page=${page}&${all ? "per_page=all" : ""}`);
  }
  getBanner(bannerId) {
    return this.apiRequest(`get`, `banners/${bannerId}`);
  }
  deleteBanner(bannerId) {
    return this.apiRequest(`delete`, `banners/${bannerId}`);
  }
  toggleBannerStatus(bannerId) {
    return this.apiRequest(`patch`, `banners/toggle-active/${bannerId}`);
  }
  async createBanner(formData) {
    return this.apiRequest(
      `post`,
      `banners`,
      formData,
      true,
      true
    );
  }

  async updateBanner(formData,bannerId) {
    return this.apiRequest(
      `post`,
      `banners/${bannerId}`,
      formData,
      true,
      true
    );
  }

  async balkInsertInvoiceXLSX(formData) {
    return this.apiRequest(
      `post`,
      `orders/buy-product-with-excel`,
      formData,
      true,
      true
    );
  }
 
  getUserBanners() {
    return this.apiUserRequest(`get`, `banners`);
  }
  //------------------------End Banners ----------------------------------------------
}
export default arefApi;
